import Scorer from "xgboost-scorer";
import XGBoostModel from "./xgboost_ef.json";

const colors = [
  "#008000",
  "#168b00",
  "#2e9700",
  "#44a200",
  "#5cae00",
  "#72b900",
  "#8ac500",
  "#a0d000",
  "#b8dc00",
  "#cee700",
  "#e6f300",
  "#fcfe00",
  "#ffea00",
  "#ffd400",
  "#ffbc00",
  "#ffa600",
  "#ff8e00",
  "#ff7600",
  "#ff6000",
  "#ff4800",
  "#ff3200",
  "#ff1a00",
  "#ff0400",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
];
const significantDimensions = [0, 4, 5, 7, 8, 9, 10, 11, 12, 14, 15, 16, 18, 21, 22, 24, 25, 26, 29, 30, 31];

async function getXGBoostPrediction(encoding: number[]): Promise<any> {
  const significantEncoding = significantDimensions.map((i) => encoding[i]);

  const scorer = await Scorer.create(XGBoostModel);
  const score = scorer.score(significantEncoding.reduce((a, v, i) => ({ ...a, [`f${String(i)}`]: v }), {}));
  return score;
}

export default [
  {
    id: "All/EF",
    value: "All/EF",
    label: "All / EF",
    patientGroup: "All patients",
    predictedOutcome: "Risk of left ventricular ejection fraction <40%",
    link: "https://decoder.ecgx.ai",
    paper: {
      text: `This model was trained on 39,603 matched ECG-echocardiogram 
        pairs of 22,676 patients in one academic hospitals to predict 
        a reduced left ventricular ejection fraction (LVEF) of less than 40%.
        The background paper is currently under review.`,
      link: "https://www.medrxiv.org/content/10.1101/2022.01.04.22268759v1",
    },
    baseValue: 17,
    colors: colors,
    probability: getXGBoostPrediction,
  },
];
